module.exports = __webpack_public_path__ + "static/media/inventory.419e3120.gif";